const ScrollMagic = require('scrollmagic');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /**
     * ScrollMagic
     * @link https://github.com/janpaepke/ScrollMagic
     */
    var controller = new ScrollMagic.Controller();

    let animation = (triggerElement, animationContainer, animationElement) => {
        new ScrollMagic.Scene({ triggerElement, triggerHook: 1 })
            .setClassToggle([animationContainer, animationElement], 'animation-mobile')
            .addTo(controller);
    };

    if ($('.animation-buttons').length > 0) {
        let triggerElement = $('.animation-trigger-buttons')[0];

        $('.animation-buttons-container').each((i, e) => {
            let animationContainer = $(e)[0],
                animationElement = $(e).find($('.animation-buttons'))[0];

            animation(triggerElement, animationContainer, animationElement);
        });
    }

    if ($('.link-to-region').length > 0) {
        $('.instructions, .deptos, .terms').each(function () {
            let triggerElement = this;

            new ScrollMagic.Scene({ triggerElement })
                .setClassToggle(triggerElement, 'animation-active')
                .on('enter leave', function () {
                    let link = $('.animation-active').last().attr('data-id');

                    $('.link-to-region').removeClass('active');
                    $('a[href="#' + link + '"]').addClass('active');

                    $('.animation-active').hasClass('instructions')
                        ? $('.bonus-download-container').addClass('active')
                        : $('.bonus-download-container').removeClass('active');
                })
                .addTo(controller);
        });
    }

    /*
     * Scroll to section page if path contains hash properties.
     */
    if (window.location.hash && $(window.location.hash) != null) {
        let hash = window.location.hash.split('#')[1],
            top = $(document).width() > 767 ? 200 : 150;

        $('html, body').animate({ scrollTop: $('[data-id=' + hash + ']').offset().top - top }, 1000);
    }

    if ($(document).width() > 639) {
        $('.collapse-footer a[data-toggle="collapse-open"]').addClass('show');
        $('.collapse-footer .collapse').addClass('in');
    }
});
